<form [formGroup]="fgTermsAndConditions" (keyup.enter)="onAcceptClicked()">
  <div class="form-group mb-4">
    <div class="flex flex-column gap-4">
      <div class="flex">
        <p-checkbox formControlName="termsAndConditions" [binary]="true" inputId="termsAndConditions"></p-checkbox>
        <label class="fw-semibold checkbox-label" for="termsAndConditions">
          I ACCEPT THE
          <a
            href="../../../assets/documents/TermsAndConditions-03-10-23.pdf"
            target="_blank"
            rel="noopener noreferrer"
            class="text-decoration-underline"
          >
            TERMS AND CONDITIONS
          </a>
        </label>
      </div>
      <div class="flex">
        <p-checkbox formControlName="privacyPolicy" [binary]="true" inputId="privacyPolicy"></p-checkbox>
        <label class="fw-semibold checkbox-label" for="privacyPolicy">
          I ACCEPT THE
          <a
            href="../../../assets/documents/PrivacyPolicy-03-10-23.pdf"
            target="_blank"
            rel="noopener noreferrer"
            class="text-decoration-underline"
          >
            PRIVACY POLICY
          </a>
        </label>
      </div>
      <div class="flex">
        <p-checkbox formControlName="merchantFunded" [binary]="true" inputId="merchantFunded"></p-checkbox>
        <label class="fw-semibold checkbox-label" for="merchantFunded"
          >I UNDERSTAND THAT ALL REWARDS ARE MERCHANT FUNDED</label
        >
      </div>
      <div class="flex">
        <p-checkbox formControlName="monthlySubscription" [binary]="true" inputId="monthlySubscription"></p-checkbox>
        <label class="fw-semibold checkbox-label" for="monthlySubscription"
          >AFTER THE FREE TRIAL PERIOD, I UNDERSTAND THE SERVICE WILL REQUIRE A MONTHLY SUBSCRIPTION</label
        >
      </div>
    </div>
  </div>

  <div class="mb-4">
    <p-button [label]="buttonLabel" [loading]="isLoading" (onClick)="onAcceptClicked()" [disabled]="!isFormValid()">
    </p-button>
  </div>
</form>
